// Perfil do próprio consultor sobre lib/api (GET/PATCH /api/consultants/me)
import { api } from './api';

export interface ApiConsultantProfile {
  id: string;
  userId: string;
  displayName: string;
  bio: string | null;
  photoUrl: string | null;
  specialties: string[];
  rateCredits: number;
  status: string;
  createdAt: string;
}

export type ConsultantPatch = {
  displayName?: string;
  bio?: string;
  photoUrl?: string;
  rateCredits?: number;
  available?: boolean;
};

export const consultantsApi = {
  me: () => api.get<{ consultant: ApiConsultantProfile }>('/consultants/me'),
  patchMe: (patch: ConsultantPatch) =>
    api.patch<{ consultant: ApiConsultantProfile }>('/consultants/me', patch),
};